var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.1875 45.9543C96.1875 51.351 91.3236 56.2575 83.4103 59.8185C75.5029 63.3769 64.5745 65.5793 52.5 65.5793C40.4255 65.5793 29.4971 63.3769 21.5897 59.8185C13.6764 56.2575 8.8125 51.351 8.8125 45.9543C8.8125 40.5577 13.6764 35.6512 21.5897 32.0902C29.4971 28.5318 40.4255 26.3293 52.5 26.3293C64.5745 26.3293 75.5029 28.5318 83.4103 32.0902C91.3236 35.6512 96.1875 40.5577 96.1875 45.9543Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.3125 67.8296V52.9685C106.259 53.9024 114.974 56.3446 121.205 59.7361C127.454 63.1371 131.188 67.4822 131.188 72.2046C131.188 77.6061 126.326 82.5127 118.414 86.0724C110.508 89.6295 99.5792 91.8296 87.5 91.8296C76.914 91.8296 67.1838 90.1216 59.6278 87.34C69.9879 86.5778 79.1171 84.1826 85.6764 80.7571C92.2924 77.3019 96.3125 72.7878 96.3125 67.8296Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 65.6418C76.6625 65.6418 96.25 56.8275 96.25 45.9543C96.25 35.0812 76.6625 26.2668 52.5 26.2668C28.3375 26.2668 8.75 35.0812 8.75 45.9543C8.75 56.8275 28.3375 65.6418 52.5 65.6418Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 45.9543V67.8293C8.75 78.7122 28.3281 87.5168 52.5 87.5168C76.6719 87.5168 96.25 78.7122 96.25 67.8293V45.9543",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64.0012V85.8762",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.25 52.8999C116.211 54.7593 131.25 62.689 131.25 72.2046C131.25 83.0874 111.672 91.8921 87.5 91.8921C76.7812 91.8921 66.9375 90.1421 59.3359 87.2983",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 87.134V94.0793C43.75 104.962 63.3281 113.767 87.5 113.767C111.672 113.767 131.25 104.962 131.25 94.0793V72.2043",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105 90.2512V112.126",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64.0012V112.126",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.4147931a2753f3a14626c3729a691c7d.svg";
export { ForwardRef as ReactComponent };